"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserInfoChat = void 0;
const mappers_1 = require("../../mappers");
const models_1 = require("../../models");
const Observable_1 = require("../../socket/Observable");
const DomainEvents_1 = require("../../utils/DomainEvents");
const Chat_1 = __importDefault(require("../Chat"));
const FilteredUserInfoChat_1 = require("./FilteredUserInfoChat");
class UserInfoChat extends Chat_1.default {
    constructor(chat, organizationUser, config, httpAdapter, socketAdapter, userDirectory, hhnStorage, chatInfoFetcher) {
        super(chat, organizationUser, config, httpAdapter, socketAdapter, userDirectory, chatInfoFetcher);
        this.hhnStorage = hhnStorage;
    }
    init() {
        super.init();
        this.removeListeners.push(this.onUserUpdate());
    }
    onUserUpdate() {
        return Observable_1.Observable.getInstance().subscribe((0, DomainEvents_1.getEventKey)(DomainEvents_1.DomainEvents.USER_UPDATE, this.organizationUser.getOrganizationId()), (data) => {
            if ((data === null || data === void 0 ? void 0 : data._id) !== this.chatInfo.id)
                return;
            const mapped = (0, mappers_1.userInfoMapper)(data);
            this._chatInfo = Object.assign(Object.assign({}, this._chatInfo), mapped);
            this.notifyChange();
        });
    }
    getChatId() {
        return this.chatInfo.id;
    }
    getChatType() {
        return models_1.CHAT_TYPE.PRIVATE;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    updateGroupListener(cb) {
        return () => { };
    }
    openFilteredChat() {
        const { groupType } = this.chatInfo;
        const existingFilteredChat = this.hhnStorage.filteredChatStorage.getPrivateChat(this.getChatId());
        existingFilteredChat === null || existingFilteredChat === void 0 ? void 0 : existingFilteredChat.destory();
        const filteredChat = new FilteredUserInfoChat_1.FilteredUserInfoChat(this.chatInfo, this.organizationUser, this.httpAdapter, this.socketAdapter, this.userDirectory);
        filteredChat.init();
        this.hhnStorage.filteredChatStorage.addChatByType(groupType, filteredChat);
        return filteredChat;
    }
}
exports.UserInfoChat = UserInfoChat;
